import { FormikHelpers } from 'formik';

type ApiErrorsReturn<T> = {
  setApiErrors: (
    actions: FormikHelpers<T>,
    errors: Record<keyof T, string>
  ) => void;
  clearApiErrors: (actions: FormikHelpers<T>) => void;
};

export function useApiErrors<T>(): ApiErrorsReturn<T> {
  return {
    setApiErrors: (
      actions: FormikHelpers<T>,
      errors: Record<keyof T, string>
    ) => {
      actions.setFormikState(prev => {
        const status = prev?.status ? { ...prev.status } : {};

        status.apiErrors = errors;

        return { ...prev, status };
      });
    },
    clearApiErrors: (actions: FormikHelpers<T>) => {
      actions.setFormikState(prev => {
        if (!prev?.status) return prev;

        const status = { ...prev.status, apiErrors: {} };

        return { ...prev, status };
      });
    },
  };
}
